import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DomService } from '@nibtravel/shared/util/dom';
import {
  fadeInRightOnEnterAnimation,
  fadeOutRightOnLeaveAnimation,
} from 'angular-animations';
import { BehaviorSubject, Observable } from 'rxjs';

import { SidebarService } from './sidebar.service';

@Component({
  selector: 'nibtravel-sidebar',
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInRightOnEnterAnimation(), fadeOutRightOnLeaveAnimation()],
})
export class SidebarComponent implements OnInit, OnDestroy {
  @HostBinding('id') id = 'main-sidebar-host';
  @HostBinding('class') klass = 'main-sidebar-host';

  showSidebar$!: Observable<boolean>;
  sidebarSize$!: Observable<string>;
  isMobile$ = new BehaviorSubject<boolean>(false);

  @ViewChild('sidebar')
  sidebar!: ElementRef<HTMLElement>;
  document!: Document;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private sidebarService: SidebarService,
    private domService: DomService
  ) {}

  ngOnInit(): void {
    this.document = this.domService.getDocument();
    this.renderer.appendChild(this.document.body, this.el.nativeElement);
    this.showSidebar$ = this.sidebarService.showSidebar();
    this.sidebarSize$ = this.sidebarService.sidebarSize();
  }

  ngOnDestroy(): void {
    this.renderer.removeChild(this.document.body, this.el.nativeElement);
  }

  onClose(): void {
    this.sidebarService.close();
  }

  @HostListener('document:mousedown', ['$event'])
  onOverlayClicked(event: MouseEvent): void {
    const datePicker = this.document.querySelector('.mbsc-whiteLabel');
    const modal = this.document.querySelector('.modal.open');
    if (this.sidebar !== undefined && !datePicker && !modal) {
      const clickOnSidebar = this.doesClickOnTargetElement(
        event,
        this.sidebar.nativeElement
      );
      if (!clickOnSidebar) {
        const cancelButtonOnSideBar: HTMLButtonElement | null =
          this.document.querySelector('[data-e2e="qqc-button-cancel-quote"]');
        if (cancelButtonOnSideBar) {
          cancelButtonOnSideBar.click();
        }
      }
    }
  }

  private doesClickOnTargetElement(
    clickEvent: MouseEvent,
    targetElement: HTMLElement
  ) {
    let clickTarget = clickEvent.target as HTMLElement | null;
    let clickOnHost = true;
    while (clickTarget !== null) {
      clickOnHost = clickTarget === targetElement; // the input
      if (clickOnHost) {
        break;
      }
      clickTarget = clickTarget.parentElement;
    }
    return clickOnHost;
  }
}
